<template>
  <div class="card-dialog">
    <el-dialog width="850px" :visible="true" center @close="handleClose()" :title="$t('address.address15')">
      <el-form :model="addressInfo" :rules="rules" ref="replyInfo" label-width="210px" class="demo-replyInfo">
        <div class="inputBox">
          <el-form-item prop="receiverName" :label="$t('addr.addr4')">
            <el-input v-model="addressInfo.receiverName" :placeholder="$t('addr.addr32')"></el-input>
          </el-form-item>
          <el-form-item prop="receiverPhone" :label="$t('addr.addr16')">
            <el-input v-model="addressInfo.receiverPhone" type="number" :placeholder="$t('addr.addr33')"></el-input>
          </el-form-item>
        </div>
        <el-form-item :label="$t('addr.addr26')" prop="address">
          <el-cascader style="width:100%" size="large" :placeholder="$t('addr.addr27')" v-model="addressInfo.address"
                       :options="options" :props="defaultParams" @change="addressChange">
          </el-cascader>

        </el-form-item>
        <el-form-item prop="postcode" :label="$t('addr.addr28')">
          <el-input v-model="addressInfo.postcode" :placeholder="$t('addr.addr28')"></el-input>
        </el-form-item>
        <el-form-item prop="addressInfo" :label="$t('addr.addr29')">
          <el-input type="textarea" :placeholder="$t('addr.addr30')" :rows="3" size="medium" v-model="addressInfo.addressInfo"
                    resize="none"></el-input>
        </el-form-item>
        <el-form-item :label="$t('addr.addr20')">
          <el-input type="textarea" v-model="addressInfo.notes" :rows="3" size="medium" :placeholder="$t('addr.addr20')"
                    resize="none"></el-input>
        </el-form-item>
        <el-form-item :label="$t('addr.addr31')">
          <el-switch inactive-value="0" active-value="1" v-model="addressInfo.defaultAddress">
          </el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">{{$t('cancel')}}</el-button>
        <el-button type="primary" @click="save('replyInfo')">{{$t('confirm')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import {CodeToText} from "element-china-area-data";

  export default {
    name: "importerAddress",
    data(){
      return{
        addressInfo: {
          type: '0',
          defaultAddress: '0',
          address: [],
        },
        rules: {
          receiverName: [
            { required: true, message: this.$t('addr.addr32'), trigger: 'blur' }
          ],
          receiverPhone: [
            { required: true, message: this.$t('addr.addr33'), trigger: 'blur' }
          ],
          addressInfo: [
            { required: true, message: this.$t('addr.addr34'), trigger: 'blur' }
          ],
          postcode: [
            { required: true, message: this.$t('addr.addr35'), trigger: 'blur' }
          ],
          addressNo: [
            { required: true, message: this.$t('addr.addr36'), trigger: 'blur' }
          ],
          address: [
            { type: 'array', required: true, message: this.$t('addr.addr37'), trigger: "blur" }
          ],
        },
        options: [],
        defaultParams: {
          label: 'text',
          value: 'id',
          children: 'children',
          expandTrigger: 'click',
          checkStrictly: false
        },
      }
    },
    created() {
      this.getAddressList_rp();
    },
    methods: {
      async getAddressList_rp () {   //获取地址列表
        let url = 'cms/configAccountNumber/getAddressList';
        const { data: res } = await this.$http.get(url)
        this.options = this.getTreeData(res.data)
        console.log(res)
      },
      getTreeData (data) {
        // 循环遍历json数据
        for (var i = 0; i < data.length; i++) {
          if (data[i].levelType !== '4') {
            if (data[i].children.length < 1) {
              // children若为空数组，则将children设为undefined
              data[i].children = undefined;
            } else {
              // children若不为空数组，则继续 递归调用 本方法
              this.getTreeData(data[i].children);
            }
          } else {
            continue
          }

        }
        return data;
      },
      addressChange (arr) {
        // console.log(arr)
        console.log(CodeToText[arr[0]], CodeToText[arr[1]], CodeToText[arr[2]]);
        this.addressInfo.provence = CodeToText[arr[0]];
        this.addressInfo.city = CodeToText[arr[1]];
        this.addressInfo.area = CodeToText[arr[2]];
      },
      save (formName) {         //保存
        this.$refs[formName].validate((valid) => {
          if (valid) {
            console.log(this.addressInfo)
            this.addressInfo.provence = this.addressInfo.address[0]
            this.addressInfo.city = this.addressInfo.address[1]
            this.addressInfo.area = this.addressInfo.address[2]
            this.$http.post('cms/configAddressInfo/insertAndEdit', this.addressInfo).then(res => {
              if (res.data.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.data.message
                })
                this.$options.confirm();
              } else {
                this.$message({
                  type: 'warning',
                  message: res.data.message
                })
              }
            })
          } else {
            this.$message.error(this.$t('addr.addr38'));
            return false;
          }
        });
      },
      handleClose(){
        this.$options.cancel('cancel')
      },
    }
  }
</script>

<style scoped lang="scss">
  .inputBox {
    width: 100%;
    display: flex;
  }
</style>
